import { Routes, Route } from "react-router-dom";
import { Page } from "./types";
import ScrollToTop from "./ScrollToTop";
import Footer from "shared/Footer/Footer";
import Page404 from "containers/Page404/Page404";
import ListingCarPage from "containers/ListingCarPage/ListingCarPage";
import CheckOutPage from "containers/CheckOutPage/CheckOutPage";
import PageContact from "containers/PageContact/PageContact";
import SiteHeader from "containers/SiteHeader";
import PageHome from "containers/PageHome/PageHome";
import ListingCarDetailPage from "containers/ListingDetailPage/listing-car-detail/ListingCarDetailPage";
import AvailableCarsPage from "containers/AvailableCarsPage/AvailableCarsPage";
import BookingDetailsPage from "containers/BookingDetailsPage/BookingDetailsPage";
import CarListingDetailPage from "containers/CarListingDetailPage/CarListingDetailPage";
import PrivacyPolicy from "components/PrivacyPolicy/PrivacyPolicyPage";
import PageAbout from "containers/PageAbout/PageAbout";

export const pages: Page[] = [
  { path: "/", exact: true, component: PageHome },
  { path: "/home-3", component: PageHome },
  { path: "/available-car", component: AvailableCarsPage },
  { path: "/vehicles", component: ListingCarPage },
  { path: "/booking-details", component: BookingDetailsPage },
  { path: "/listing-car-detail", component: ListingCarDetailPage },
  { path: "/checkout", component: CheckOutPage },
  { path: "/privacy-policy", component: PrivacyPolicy },
  { path: "/contact", component: PageContact },
  { path: "/about", component: PageAbout },
  { path: "/car-listing-detail", component: CarListingDetailPage },
];

export enum AuthPages {
  Login,
  Signup,
  ForgotPass,
}

const MyRoutes = () => {
  return (
    <div className="min-h-screen flex flex-col justify-between">
      <ScrollToTop />
      <SiteHeader />

      <Routes>
        {pages.map(({ component, path }) => {
          const Component = component;
          return <Route key={path} element={<Component />} path={path} />;
        })}
        <Route element={<Page404 />} />
      </Routes>
      <Footer />
    </div>
  );
};

export default MyRoutes;
